import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import usePostAxiosData from "hooks/usePostAxiosData";
import { useEffect } from "react";
import toast from "react-hot-toast";
import InputField from "components/fields/InputField";
import Error from "components/message/Error";
import { Button, Stack } from "@chakra-ui/react";
import { useAuthUser } from "react-auth-kit";
import useDataFetching from "hooks/useDataFetching";
import { config } from "variables/config";
import { AppBar, Dialog, DialogActions, DialogContent, Divider, Toolbar } from "@mui/material";
import MuiSelect from "components/MuiSelect";
import { CloseModalButton } from "components/Utils";
import MuiDatePicker from "components/MuiDatePicker";
import dayjs from "dayjs";
import { REPORT_TYPE } from "Constaints";
import { ENTERPRISE_STATUS } from "Constaints";
import AddSpyEnterprise from "./AddSpyEnterprise";
import { useTranslation } from "react-i18next"; // Importez useTranslation

const AddRepport = ({ isOpen, onClose, get, selectedReportP }) => {
  const { t } = useTranslation("reports"); // Utilisez le namespace 'reports'

  const [selectedReport, setSelectedReport] = useState(selectedReportP || null);
  const [canEdit, setCanEdit] = useState(true);

  /** Form validation config */
  const schema = yup.object().shape({
    title: yup.string().required(t("field_required")), // Traduit
    description: yup.string(),
    enterpriseNumber: yup.number().nullable(),
    employeeNumber: yup.number().nullable(),
    images: yup.mixed(),
  });

  const [region, setRegion] = useState(null);
  const [departement, setDepartement] = useState(null);
  const [arrondissement, setArrondissement] = useState(null);
  const [zone, setZone] = useState(null);
  const [subZone, setSubZone] = useState("");
  const [itinerary, setItinerary] = useState("");
  const [usedTools, setUsedTools] = useState([]);
  const [transportationMode, setTransportationMode] = useState([]);
  const [status, setStatus] = useState("");
  const [end, setEnd] = useState(null);
  const [date, setDate] = useState(null);
  const [agentIds, setAgentIds] = useState([]);
  const [teamLeaderId, setTeamLeaderId] = useState(null);
  const [phone, setPhone] = useState("");
  const [reportTypeList, setReportTypeList] = useState([]);
  const [images, setImages] = useState([]);
  const [reportFile, setReportFile] = useState(null);

  const auth = useAuthUser();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });
  console.log("🚀 ~ AddRepport ~ errors:", errors);

  const [loadingR, errorR, regions] = useDataFetching(`${config.app.api_url}/regions`);
  const [loadingD, errorD, departments] = useDataFetching(
    region ? `${config.app.api_url}/regions/${region}/departments` : null
  );
  const [loadingA, errorA, arrondissements] = useDataFetching(
    departement ? `${config.app.api_url}/departments/${departement}/arrondissements` : null
  );
  const [loadingZ, errorZ, zones] = useDataFetching(`${config.app.api_url}/zones`);

  const [loadingU, errorU, users, fetchDataU] = useDataFetching(
    `${config.app.api_url}/roles/3/users`
  );
  /** post create report */
  const [loading, postAxiosData, errorMassage, successMessage, result] = usePostAxiosData(
    `reports/doc`,
    "POST",
    true,
    "multipart/form-data"
  );

  const handleSave = async (dataYub) => {
    const formatDate = (dateObj) => (dateObj ? dayjs(dateObj).format("YYYY-MM-DD") : null);

    console.log("🚀 ~ handleSave ~ agentIds:", agentIds);
    const data = {
      ...dataYub,
      date: formatDate(date),
      end: formatDate(end),
      agentIds: agentIds || [],
      teamLeaderId,
      phone,
      transportationMode,
      usedTools,
      enterpriseNumber: dataYub?.enterpriseNumber,
      employeeNumber: dataYub?.employeeNumber,
      status: status || null,
      reportTypeList: reportTypeList,
      title: dataYub.title,
      description: dataYub.description,
      zoneId: zone,
      subZone,
      itinerary,
      creatorId: auth()?.user?.id,
      regionId: region,
      arrondissementId: arrondissement,
      departmentId: departement,
    };

    let formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== undefined) {
        if (Array.isArray(data[key])) {
          data[key].forEach((item) => formData.append(key, item));
        } else {
          formData.append(key, data[key]);
        }
      }
    });

    // Append reportFile
    if (reportFile && reportFile.length > 0) {
      formData.append("reportFile", reportFile[0]);
    }

    // Append images
    if (images && images.length > 0) {
      Array.from(images).forEach((file) => formData.append("images", file));
    }

    await postAxiosData(formData);
  };

  const handleReset = () => {
    setRegion(null);
    setDepartement(null);
    setArrondissement(null);
    setZone(null);
    setSubZone("");
    setItinerary("");
    setUsedTools([]);
    setTransportationMode([]);
    setStatus("");
    setDate(null);
    setEnd(null);
    setAgentIds([]);
    setTeamLeaderId(null);
    setPhone("");
    setReportTypeList([]);
    setImages([]);
    setReportFile(null);
    reset({
      title: "",
      description: "",
      enterpriseNumber: "",
      employeeNumber: "",
      images: [],
    });
  };

  const handleCloseInside = () => {
    handleReset();
    onClose();
  };

  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      handleCloseInside();
      setSelectedReport(result?.data);
      setOpenAddEnterModal(true);
      get();
      toast.success(
        `${
          successMessage?.message != null
            ? successMessage?.message
            : t("report_added_success") // Traduit
        } `,
        {
          duration: 4000,
          className: "bg-success text-white",
        }
      );
    }
  }, [successMessage]);

  useEffect(() => {
    if (selectedReport) {
      setCanEdit(false);
      setValue("title", selectedReport?.title);
      setValue("description", selectedReport?.description);
      setValue("enterpriseNumber", selectedReport?.enterpriseNumber);
      setValue("employeeNumber", selectedReport?.employeeNumber);
      setValue("date", dayjs(selectedReport?.date));
      setValue("end", dayjs(selectedReport?.end));
      setRegion(selectedReport?.regionId);
      setDepartement(selectedReport?.departmentId);
      setArrondissement(selectedReport?.arrondissementId);
      setZone(selectedReport?.zoneId);
      setSubZone(selectedReport?.subZone);
      setItinerary(selectedReport?.itinerary);
      setPhone(selectedReport?.phone);
      setTransportationMode(selectedReport?.transportationMode);
      setUsedTools(selectedReport?.usedTools || []);
      setStatus(ENTERPRISE_STATUS[selectedReport?.status]);
      setAgentIds(selectedReport?.agents || []);
    }
  }, [selectedReport]);
  const [openAddEnterModal, setOpenAddEnterModal] = useState(false);

  return (
    <>
      {selectedReport && (
        <AddSpyEnterprise
          referenceReport={selectedReport}
          isOpen={openAddEnterModal}
          onClose={handleCloseInside}
          get={() => {}}
        />
      )}

      <Dialog fullWidth maxWidth="lg" aria-labelledby="customized-dialog-title" open={isOpen}>
        <form onSubmit={handleSubmit(handleSave)}>
          <AppBar sx={{ position: "relative" }}>
            <Toolbar className="bg-gray-50 text-green-500 flex justify-between items-center">
              <h1 className="text-2xl font-bold">{t("add_report")}</h1> {/* Traduit */}
              <CloseModalButton iconColor={"red"} handleClose={handleCloseInside} />
            </Toolbar>
          </AppBar>
          <DialogContent className="flex flex-col items-center justify-between gap-4" dividers>
            {errorMassage?.message && (
              <div className="flex flex-col items-center justify-between mb-4">
                <Error message={errorMassage?.message} />
              </div>
            )}
            <div className="my-4 grid gap-2 md:grid-cols-2 w-full">
              <MuiDatePicker
                name="date"
                wrapperClasses="flex-1 filter-item anime slideLeft"
                error={errors.date?.message || ""}
                onChange={(value) => setDate(value)}
                value={date}
                fullWidth
                label={t("start_date")} // Traduit
              />

              <MuiDatePicker
                name="end"
                wrapperClasses="flex-1 filter-item anime slideLeft"
                error={errors.end?.message || ""}
                onChange={(value) => setEnd(value)}
                value={end}
                fullWidth
                label={t("end_date")} // Traduit
              />

              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t("title")} // Traduit
                required
                placeholder={t("add_a_title")} // Traduit
                id="title"
                name="title"
                type="text"
                error={errors.title?.message || ""}
              />
              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t("description")} // Traduit
                placeholder={t("description")} // Traduit
                id="description"
                name="description"
                type="text"
                multiline
                error={errors.description?.message || ""}
              />
              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t("number_of_enterprises")} // Traduit
                placeholder={t("number_of_enterprises")} // Traduit
                id="enterpriseNumber"
                name="enterpriseNumber"
                type="number"
                error={errors.enterpriseNumber?.message || ""}
              />
              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t("number_of_employees")} // Traduit
                placeholder={t("number_of_employees")} // Traduit
                id="employeeNumber"
                name="employeeNumber"
                type="number"
                error={errors.employeeNumber?.message || ""}
              />
              <MuiSelect
                disabled={!canEdit}
                label={t("region")} // Traduit
                value={region}
                name="region"
                options={regions.data}
                format={{ value: "id", label: "name" }}
                onChange={(e) => setRegion(e.target.value)}
                emptyLabel={t("none")} // Traduit
              />
              <MuiSelect
                label={t("department")} // Traduit
                value={departement}
                options={departments.data}
                name="departement"
                format={{ value: "id", label: "name" }}
                onChange={(e) => setDepartement(e.target.value)}
                emptyLabel={t("none")} // Traduit
              />
              <MuiSelect
                disabled={!canEdit}
                label={t("arrondissement")} // Traduit
                value={arrondissement}
                options={arrondissements.data}
                name="arrondissement"
                format={{ value: "id", label: "name" }}
                onChange={(e) => setArrondissement(e.target.value)}
                emptyLabel={t("none")} // Traduit
              />
              <MuiSelect
                disabled={!canEdit}
                label={t("zone")} // Traduit
                value={zone}
                options={zones.data}
                name="zone"
                format={{ value: "id", label: "description" }}
                onChange={(e) => setZone(e.target.value)}
                emptyLabel={t("none")} // Traduit
              />
              <InputField
                label={t("sub_zone")} // Traduit
                value={subZone}
                onChange={(e) => setSubZone(e.target.value)}
                name="subZone"
                id="subZone"
                type="text"
                extra="mb-3"
              />
              <InputField
                label={t("itinerary")} // Traduit
                value={itinerary}
                onChange={(e) => setItinerary(e.target.value)}
                name="itinerary"
                id="itinerary"
                type="text"
                extra="mb-3"
              />
              <InputField
                label={t("phone")} // Traduit
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                name="phone"
                id="phone"
                type="text"
                extra="mb-3"
              />
              <MuiSelect
                label={t("transport_mode")} // Traduit
                value={transportationMode}
                options={[
                  { value: "BUS", label: t("bus") }, // Traduit
                  { value: "CAR", label: t("car") }, // Traduit
                  { value: "WALK", label: t("walk") }, // Traduit
                ]}
                name="transportationMode"
                onChange={(e) => setTransportationMode(e.target.value)}
                emptyLabel={t("none")} // Traduit
              />

              <MuiSelect
                label={t("report_type")} // Traduit
                value={reportTypeList}
                options={Object.values(REPORT_TYPE).map((rt) => ({
                  value: rt.name,
                  label: rt.name,
                }))}
                name="reportTypeList"
                onChange={(e) => {
                  const value = e.target.value;
                  setReportTypeList(Array.isArray(value) ? value : [value]);
                }}
                emptyLabel={t("none")} // Traduit
                multiple
              />
              <MuiSelect
                disabled={!canEdit}
                label={t("agents")} // Traduit
                value={agentIds}
                options={users?.data?.filter((u) => u?.enable).map((u) => ({
                  id: u.id,
                  name: `${u.firstName} ${u.lastName}`,
                }))}
                name="agents"
                format={{ value: "id", label: "name" }}
                onChange={(e) => {
                  setAgentIds(e.target.value);
                }}
                emptyLabel={t("none")} // Traduit
                multiple={true}
              />

              <MuiSelect
                disabled={!canEdit}
                label={t("team_leader")} // Traduit
                value={teamLeaderId}
                options={users?.data?.filter((u) => u?.enable).map((u) => ({
                  id: u.id,
                  name: `${u.firstName} ${u.lastName}`,
                }))}
                name="agents"
                format={{ value: "id", label: "name" }}
                onChange={(e) => setTeamLeaderId(e.target.value)}
                emptyLabel={t("none")} // Traduit
              />
              <InputField
                label={t("tools_used")} // Traduit
                value={usedTools}
                onChange={(e) => setUsedTools(e.target.value.split(",").map((s) => s.trim()))}
                name="usedTools"
                id="usedTools"
                type="text"
                extra="mb-3"
              />
            </div>
            <Stack direction="row" gap={3} className="w-full">
              <Divider className="my-4" />
              <div className="flex flex-col items-center justify-center gap-4 w-full bg-orange-50 p-4 rounded-md shadow-md">
                <label
                  htmlFor="report-file-upload"
                  className="cursor-pointer flex flex-col items-center justify-center border-2 border-dashed border-green-300 rounded-lg p-6 hover:bg-green-400 hover:border-white text:gray-400 hover:text-white transition duration-300"
                >
                  <span className="text-sm ">
                    {t("click_to_upload_report")}
                  </span>{" "}
                  {/* Traduit */}
                </label>
                <input
                  id="report-file-upload"
                  type="file"
                  name="reportFile"
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={(e) => setReportFile(e.target.files)}
                  required
                />
                {errors?.reportFile?.message && (
                  <p className="text-sm text-red-500 mt-2">
                    {errors.reportFile.message}
                  </p>
                )}
              </div>
              <div className="flex flex-col items-center justify-center gap-4 w-full bg-orange-50 p-4 rounded-md shadow-md">
                <label
                  htmlFor="images-upload"
                  className="cursor-pointer flex flex-col items-center justify-center border-2 border-dashed border-green-300 rounded-lg p-6 hover:bg-green-400 hover:border-white text:gray-400 hover:text-white transition duration-300"
                >
                  <span className="text-sm ">
                    {t("click_to_upload_images")}
                  </span>{" "}
                  {/* Traduit */}
                </label>
                <input
                  id="images-upload"
                  type="file"
                  name="images"
                  accept=".jpeg,.jpg,.png"
                  multiple
                  onChange={(e) => setImages(e.target.files)}
                />
              </div>
            </Stack>
          </DialogContent>
          <DialogActions className="flex justify-between">
            <Button onClick={handleCloseInside}>{t("cancel")}</Button> {/* Traduit */}
            <Button
              type="submit"
              colorScheme="green"
              isLoading={false}
              loadingText={t("saving")} // Traduit
            >
              {t("save")} {/* Traduit */}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
export default AddRepport;